const APP_CUSTOM_EVENT_KEY = {
    IAP: 'IAP',
    IAP_V2: 'IAP_v2'
}

const APP_METHOD_KEY = {
    FACEBOOK_ANALYTICS: 'fb_analytics',
    PIXEL_ANALYTICS: 'pixel_analytics',
    ADJUST_ANALYTICS: 'adjust_analytics',
    APP_GALLERY: 'appgallery',
    CONVERT_MP4: 'convertmp4',
    VIDEO_SHARE: 'videoshare',
    LINK_SHARE: 'linkshare',
    LINK_SHARE_V2: 'linkshare_v2',
    APP_PUSH: 'apppush',
    LINE_LOGIN: 'line_login',
    REVIEW: 'review',
    IAP: 'IAP',
    IAP_V2: 'IAP_v2',
    SUBSCRIPTION: 'subscription',
    DOWNLOAD_MULTI: 'download_multi',

    /** 항상 지원 (따로 지원 여부 체크하지 않아도됨) */
    DOWNLOAD: 'download'
}

const SHARE_TYPE = {
    INSTAGRAM_STORY: 'instagram_story',
    FACEBOOK_REELS: 'facebook_reels',
    FACEBOOK_STORY: 'facebook_story',
    YOUTUBE_VIDEO: 'youtube_video',
}

const IsSupportedAppCustomEvent = () => {
    return window && window.setCustomEventListener && window.removeCustomEventListener ? true : false
}

const RegistCustomEventListener = (customEventKey, listener) => {
    if (!IsSupportedAppCustomEvent()) return
    window.setCustomEventListener(customEventKey, listener)
}

const UnregistCustomEventListener = (customEventKey) => {
    if (!IsSupportedAppCustomEvent()) return
    window.removeCustomEventListener(customEventKey)
}

const IsAppAvaliableMethod = (methodKey) => {
    if (window && window.getAvaliableMethod && window.invokeCSharpAction) {
        const avaliableMethod = window.getAvaliableMethod()
        if (avaliableMethod[methodKey]) return true
    }
    return false
}

const IsSupportedAppMethod = () => {
    return window && window.invokeCSharpAction ? true : false
}

/**
 * 여러개의 파일을 다운받는다.
 * @param {[{
 *  url: string
 *  filename: string
 *  filetype: 'image'|'video'
 * }]} params 
 */
const MultiDownload = (params = []) => {
    try {
        if (!IsSupportedAppMethod()) throw new Error('CLIENT_NOT_SUPPORTED_APP_METHOD_ERROR')
        if (!params || params.length === 0) throw new Error('CLIENT_INVALD_DATA_ERROR')

        const methodKey = APP_METHOD_KEY.DOWNLOAD_MULTI
        const json = JSON.stringify(params)

        window.invokeCSharpAction(`method=${methodKey}&json=${json}`)
    }
    catch (e) {
        throw e
    }
}

/**
 * 한개의 파일을 다운받는다.
 * @param {{
 *  url: string
 *  filename: string
 *  filetype: 'image'|'video'
 * }} param 
 */
const Download = (param = {}) => {
    try {
        const { url, filename, filetype } = param

        if (!IsSupportedAppMethod()) throw new Error('CLIENT_NOT_SUPPORTED_APP_METHOD_ERROR')
        if (!url || !filename) throw new Error('CLIENT_INVALD_DATA_ERROR')
        
        const methodKey = APP_METHOD_KEY.DOWNLOAD

        if (filetype) {
            window.invokeCSharpAction(`method=${methodKey}&url=${url}&filename=${filename}&filetype=${filetype}`)
        }
        else {
            window.invokeCSharpAction(`method=${methodKey}&url=${url}&filename=${filename}`)
        }
    }
    catch (e) {
        throw e
    }
}

/**
 * @param {{
 *  IAPCode: string
 * }} param 
 */
const InAppPurchase = (param = {}) => {
    try {
        const { IAPCode } = param
        if (!IsSupportedAppMethod()) throw new Error('CLIENT_NOT_SUPPORTED_APP_METHOD_ERROR')

        const methodKey = APP_METHOD_KEY.IAP

        window.invokeCSharpAction(`method=${methodKey}&productid=${IAPCode}`)
    }
    catch (e) {
        throw e
    }
}

/**
 * @param {{
 *  IAPCode: string
 *  paymentId: string
 * }} param 
 */
const InAppPurchaseV2 = (param = {}) => {
    try {
        const { IAPCode, paymentId } = param
        if (!IsSupportedAppMethod()) throw new Error('CLIENT_NOT_SUPPORTED_APP_METHOD_ERROR')

        const methodKey = APP_METHOD_KEY.IAP_V2

        window.invokeCSharpAction(`method=${methodKey}&productid=${IAPCode}&paymentId=${paymentId}`)
    }
    catch (e) {
        throw e
    }
}

/**
 * @param {{
 *  shareLink: string
 * }} param 
 */
const LinkShare = (param = {}) => {
    try {
        const { shareLink } = param
        if (!IsSupportedAppMethod()) throw new Error('CLIENT_NOT_SUPPORTED_APP_METHOD_ERROR')
        
        const methodKey = APP_METHOD_KEY.LINK_SHARE

        window.invokeCSharpAction(`method=${methodKey}&url=${shareLink}`)
    }
    catch (e) {
        throw e
    }
}

/**
 * @param {{
 *  shareLink: string
 * }} param 
 */
const LinkShareV2 = (param = {}) => {
    try {
        const { fileUrl, filename } = param
        if (!IsSupportedAppMethod()) throw new Error('CLIENT_NOT_SUPPORTED_APP_METHOD_ERROR')
        
        const methodKey = APP_METHOD_KEY.LINK_SHARE_V2

        window.invokeCSharpAction(`method=${methodKey}&url=${fileUrl}&filename=${filename}`)
    }
    catch (e) {
        throw e
    }
}

/**
 * SNS 및 특정 앱에 동영상 파일을 공유함
 * @iOS 파일을 기기에 다운받지 않고 URL로 공유
 * @Android File을 기기에 다운받은 후 공유, oldFilename과 같은 이름의 파일이 있는경우 해당 파일로 공유
 * @param {{
 *  shareType: string
 *  fileUrl: string
 *  filename: string
 *  oldFilename: string
 * }} param 
 */
const VideoShare = (param = {}) => {
    try {
        const { shareType, fileUrl, filename, oldFilename } = param
        if (!IsSupportedAppMethod()) throw new Error('CLIENT_NOT_SUPPORTED_APP_METHOD_ERROR')

        let isValidShareType = false
        const shareTypeKeys = Object.keys(SHARE_TYPE)
        for (let i = 0; i < shareTypeKeys.length; ++i) {
            if (SHARE_TYPE[shareTypeKeys[i]] === shareType) isValidShareType = true
        }
        if (!isValidShareType) throw new Error('CLIENT_INVALD_DATA_ERROR')

        const methodKey = APP_METHOD_KEY.VIDEO_SHARE

        let queryParams = `method=${methodKey}&url=${fileUrl}&shareType=${shareType}&filename=${filename}`
        if (oldFilename) queryParams += `&oldFilename=${oldFilename}`

        window.invokeCSharpAction(queryParams)
    }
    catch (e) {
        throw e
    }
}

export default {
    APP_CUSTOM_EVENT_KEY,
    APP_METHOD_KEY,
    SHARE_TYPE,

    IsSupportedAppCustomEvent,
    RegistCustomEventListener,
    UnregistCustomEventListener,

    IsAppAvaliableMethod,
    IsSupportedAppMethod,

    MultiDownload,
    Download,

    InAppPurchase,
    InAppPurchaseV2,

    LinkShare,
    LinkShareV2,
    VideoShare
}